import { onBeforeUnmount } from 'vue';

import { scrollToFirstFieldWithErrorOnPage } from '@/Utils/FormUtility';
import { useCheckoutValidationStore } from '@/Stores/Web/checkoutValidationStore';

// Sections of the checkout register here so that one submit can validate all of them at once.
export function useCheckoutValidator(section = null) {
    const checkoutValidationStore = useCheckoutValidationStore();

    let registeredValidator = null;

    function register(validate) {
        registeredValidator = async () => ({ isValid: await validate(), section });

        checkoutValidationStore.registerValidator(registeredValidator);
    }

    function unregister() {
        if (!registeredValidator) {
            return;
        }

        checkoutValidationStore.unregisterValidator(registeredValidator);
        registeredValidator = null;
    }

    async function validateSubmit() {
        const isValid = await checkoutValidationStore.validateAll();

        if (!isValid) {
            scrollToFirstFieldWithErrorOnPage();
        }

        return isValid;
    }

    onBeforeUnmount(unregister);

    return {
        register,
        unregister,
        validateSubmit,
    };
}
